import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-direction-icon',
    templateUrl: './direction-icon.component.html',
    styleUrls: ['./direction-icon.component.scss']
})
export class DirectionIconComponent extends AbstractIcon {
    @HostBinding('style.transform') public _direction: string;

    constructor() {
        super();

        this.direction = 'right';
        this.height = 24;
        this.width = 24;
    }

    @Input()
    public set direction(direction: string) {
        if (direction) {
            switch (direction) {
                case 'down':
                    this._direction = 'rotate(180deg)';
                    break;
                case 'left':
                    this._direction = 'rotate(-90deg)';
                    break;
                case 'up':
                    this._direction = 'rotate(0deg)';
                    break;
                default:
                    this._direction = 'rotate(90deg)';
            }
        }
    }
}
